var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mensagem"},[_vm._v("Problemas de conexão com o servidor")])}
var staticRenderFns = []

export { render, staticRenderFns }